import { Component, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-print-footer',
	templateUrl: './print-footer.component.html',
	styleUrls: ['./print-footer.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PrintFooterComponent {

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/print/footer/print-footer.component.ts